// API Configuration
export const API_ENDPOINTS = {
  WEATHER: 'https://wttr.in',
  GEOCODE: 'https://api.geoapify.com/v1/geocode/autocomplete',
};

// Default Cities
export const DEFAULT_CITIES = [
  { name: 'Lucknow', icon: '🌞' },
  { name: 'Delhi', icon: '🌤️' },
  { name: 'Bangalore', icon: '🌦️' },
  { name: 'Mumbai', icon: '🌧️' },
  { name: 'London', icon: '🌦️' },
  { name: 'New York', icon: '🗽' },
  { name: 'Paris', icon: '🗼' },
  { name: 'Tokyo', icon: '🗾' },
  { name: 'Dubai', icon: '🌇' }
];

// Weather Icon Mapping
export const WEATHER_ICONS = {
  'Clear': '☀️',
  'Sunny': '☀️',
  'Partly cloudy': '⛅',
  'Cloudy': '☁️',
  'Overcast': '☁️',
  'Mist': '🌫️',
  'Fog': '🌫️',
  'Light rain': '🌦️',
  'Moderate rain': '🌧️',
  'Heavy rain': '⛈️',
  'Light snow': '🌨️',
  'Snow': '❄️',
  'Heavy snow': '🌨️',
  'Thunder': '⚡',
  'Thunderstorm': '⛈️'
};

// Wind Direction Mapping
export const WIND_DIRECTIONS = {
  'N': 'North',
  'NNE': 'North-Northeast',
  'NE': 'Northeast',
  'ENE': 'East-Northeast',
  'E': 'East',
  'ESE': 'East-Southeast',
  'SE': 'Southeast',
  'SSE': 'South-Southeast',
  'S': 'South',
  'SSW': 'South-Southwest',
  'SW': 'Southwest',
  'WSW': 'West-Southwest',
  'W': 'West',
  'WNW': 'West-Northwest',
  'NW': 'Northwest',
  'NNW': 'North-Northwest'
};

// Configuration Constants
export const CONFIG = {
  MAX_RECENT_SEARCHES: 5,
  SEARCH_DEBOUNCE_MS: 300,
  MIN_SEARCH_LENGTH: 2,
  DAY_START_HOUR: 6,
  DAY_END_HOUR: 18,
  TOAST_AUTO_CLOSE: 3000,
};

// Error Messages
export const ERROR_MESSAGES = {
  WEATHER_FETCH_FAILED: 'Unable to fetch weather data. Please try again.',
  LOCATION_FETCH_FAILED: 'Unable to fetch location suggestions.',
  GEOLOCATION_DENIED: 'Location access denied. Please enable location services.',
  GEOLOCATION_UNAVAILABLE: 'Location services are not available.',
  GEOLOCATION_TIMEOUT: 'Location request timed out.',
  NETWORK_ERROR: 'Network error. Please check your connection.',
};

// Temperature Units
export const TEMPERATURE_UNITS = {
  CELSIUS: 'C',
  FAHRENHEIT: 'F',
};
